import { render, staticRenderFns } from "./SveiConfigurazionePuntiIncontroEditComponent.vue?vue&type=template&id=a9e99c48"
import script from "./SveiConfigurazionePuntiIncontroEditComponent.vue?vue&type=script&lang=js"
export * from "./SveiConfigurazionePuntiIncontroEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports